import { mapGetters, mapMutations } from "vuex";
import { Tabs, Tab } from "vue-slim-tabs";
import { VueSlideToggle } from "vue-slide-toggle";

export default {
    name: "catalog-list",
    props: ["subItem"],
    data() {
        return {
            openChilds: false,
        };
    },
    components: {
        Tabs,
        Tab,
        VueSlideToggle,
    },
    computed: {
        ...mapGetters({
            showCatalogMenu: "system/showCatalogMenu",
        }),
    },
    created() {},
    methods: {
        ...mapMutations({
            changeShowCatalogMenu: `system/CHANGE_SHOW_CATALOG_MENU`,
        }),
        navigateTo() {
            if (!this.subItem.childs.length) {
                this.$router
                    .push({
                        name: "categories",
                        params: { lang: this.$route.params.lang, categorySlug: this.subItem.slug },
                    })
                    .catch(() => {
                        console.log("");
                    });
            } else {
                this.$router.push({ name: "category-page", params: { categorySlug: this.subItem.slug } }).catch(() => {
                    console.log("");
                });
            }
        },
        changeShowCatalog() {
            if (this.showCatalogMenu) {
                this.changeShowCatalogMenu(false);
            } else {
                this.changeShowCatalogMenu(true);
            }
        },
        changeSubMenuDropdown(subItem) {
            if (subItem.childs.length > 0) {
                this.openChilds = !this.openChilds;
            }
        },
        hideSubMenuDropdown(subItem) {
            if (this.openChilds) {
                this.openChilds = !this.openChilds;
            }
        },
    },
};
